import { createStore } from "redux";
import rootred from "./redux/reducers/Man";

const store = createStore(rootred);
export default store;
